interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const SectionWrapper: React.FC<Props> = ({ children, className = "", ...rest }) => {
  return (
    <div {...rest} className={`w-full max-w-screen-2xl px-5 sm:px-8 ${className}`}>
      {children}
    </div>
  );
};

export default SectionWrapper;
